module.exports = __webpack_public_path__ + "static/background-about-us-3ce8854d5da2652a032dd00eee3ef1e2.jpg";